import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { WindowRef } from '../../utils/window';
import { TranslateUtil } from '../../utils/translate-util';
import { SharedTranslateModule } from "../../utils/sharedTranslateModule";
import { Chart } from 'chart.js/auto';
import { SessionTimeoutComponent } from "../sessionTimeout/sessionTimeout.component";
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { FormsModule } from '@angular/forms';
import { IncidentManagementService, IncidentRecord, IncidentScreenshotPayload, IncidentAccountOption } from './incident-management.service';
import { environment } from '../../../environments/environment';


@Component({
  selector: "div.dtf-incidentManagement",
  imports: [SharedTranslateModule, SessionTimeoutComponent, MatTableModule, MatPaginatorModule, FormsModule],
  templateUrl: './incidentManagement.component.html',
  styleUrls: ['./incidentManagement.component.scss'],
  providers: [
    //  ClassesUtil, WindowRef
  ]
})
export class incidentManagementComponent implements OnInit {
  router: Router;
  isCanadaPortal = false;
  isFrench = false;
  currentCountry: string;
  language = '';
  targetRedirect = '';
  usUrl: string;
  caUrl: string;
  incidents: IncidentRecord[] = [];
  allIncidents: IncidentRecord[] = [];
  incidentDataSource = new MatTableDataSource<IncidentRecord>([]);
  displayedColumns: string[] = ['incidentID', 'agentID', 'pageName', 'country', 'title', 'screenshots', 'status', 'createdDate', 'updatedDate'];
  showIncidentPopup = false;
  selectedIncident: IncidentRecord | null = null;
  popupMode: 'create' | 'edit' = 'edit';
  showFormErrors = false;
  incidentForm = {
    usernameOfAffectedCustomer: '',
    accountNumber: '',
    thirdParty: '',
    agentNameShortId: '',
    websitePageScreen: '',
    otherWebsitePage: '',
    country: '',
    incidentTitle: '',
    detailedDescription: '',
    screenshotAttachmentNames: [] as string[],
    screenshotAttachments: [] as IncidentScreenshotPayload[],
    screenshotPreviewUrls: [] as string[],
    pegaVerificationCompleted: false,
    additionalComments: '',
    customersImpacted: '',
    status: 'Open',
    developerResolution: ''
  };
  screenshotValidationError = '';
  statusOptions: string[] = ['Open', 'In Progress', 'Closed', 'Cancel'];
  websitePageOptions: string[] = [
    'Homepage',
    'Dashboard',
    'Login',
    'Registration',
    'View Accounts',
    'AutoPay',
    'Payoff',
    'Ebill',
    'Invoices',
    'Amortization Schedule',
    'Year End Interest Letters',
    'Document Request',
    'Title Copy',
    'State to State Transfer',
    'Insurance',
    'EV Solutions',
    'Guest Pay',
    'Online Payment',
    'Principal Payment',
    'Statement Payment',
    'Recurring Payment',
    'Manage Your Profile (Edit/Add/Delete Profile)',
    'Payment History',
    'Help (Payment Screen)',
    'Payment Log Queries',
    'Email Preferences',
    'Change Password',
    'Change of Address',
    'Connected Insurance',
    'Dynamic Financing',
    'Brochures',
    'Finance and lease solutions',
    'Career',
    'CCPA',
    'Other'
  ];
  private readonly screenshotOptionalPages = new Set([
    'Payment Log Queries',
    'Guest Pay',
    'Online Payment',
    'Principal Payment',
    'Statement Payment',
    'Recurring Payment',
    'Manage Your Profile (Edit/Add/Delete Profile)',
    'Payment History',
    'Help (Payment Screen)'
  ]);

  get isScreenshotRequired(): boolean {
    return !this.screenshotOptionalPages.has(this.incidentForm.websitePageScreen);
  }

  countryOptions = [
    { value: 'US', label: 'US' },
    { value: 'CA', label: 'Canada' }
  ];
  accountNumberOptions: IncidentAccountOption[] = [];
  filteredAccountNumberOptions: IncidentAccountOption[] = [];
  accountNumberSearchTerm = '';
  isLoadingAccountNumbers = false;
  isOpeningIncidentForm = false;
  isCreatingIncident = false;
  isUpdatingIncident = false;
  isNavigatingToDashboard = false;
  isDashboardLoading = true;
  private isDashboardDataReady = false;
  private isDashboardChartsReady = false;
  pegaLoginUrl = '';
  private readonly pegaStageUrl = 'https://dtfsus-daimr1-stg1.pegacloud.net/prweb/app/default/beEBp4uRVTogorRwSwWqbOtn9IL2fwdI*/!STANDARD';
  private readonly pegaProdUrl = 'https://dtfsus-daimr1-prod1.pegacloud.net/prweb/PRAuth/app/default/beEBp4uRVTogorRwSwWqbOtn9IL2fwdI*/!STANDARD?pzuiactionrrr=CXtpbn03aDFyT3hncERUZkpvekFYVzRBTVF3a25sM2tCT09ncWNBdHRDYndIUmMvSGxaSUk2WEZMTUx0VTRoMDNnVnJyRkNTNVFxUzlLL2psVWJMbEZYOHVzK2gwdVdEcFAzUzNwVlZnYTNiQ3BDSnJkcWF1RU5RUDNVT0VBMkdhSFduMA%3D%3D*';
  totalIncidents = 0;
  openIncidents = 0;
  inProgressIncidents = 0;
  closedIncidents = 0;
  private statusChart: Chart | null = null;
  private monthlyChart: Chart | null = null;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    router: Router,
    public translate: TranslateService,
    private _window: WindowRef,
    public translateUtil: TranslateUtil,
    private incidentManagementService: IncidentManagementService
  ) {
    this.router = router;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
    this.pegaLoginUrl = this.resolvePegaLoginUrl(this.usUrl);
  }
  ngOnInit() {
    this.loadIncidents();
    this.applyIncidentPrefillFromSession();
  }

  ngAfterViewInit(): void {
    const statusChartCanvas = document.getElementById('statusChart') as HTMLCanvasElement | null;
    const statusChartContext = statusChartCanvas?.getContext('2d') || undefined;
    const statusChartColors = this.buildStatusChartGradients(statusChartContext);

    this.statusChart = new Chart("statusChart", {

      type: 'doughnut',

      data: {

        labels: ['Open', 'In Progress', 'Closed'],

        datasets: [

          {

            data: [0, 0, 0],

            backgroundColor: [

              statusChartColors.open,

              statusChartColors.inProgress,

              statusChartColors.closed

            ],

            borderColor: [

              '#d9b562',

              '#4d8fd1',

              '#72b48a'

            ],

            borderWidth: 1

          }

        ]

      },
      options: {
        animation: false,
        responsive: true,
        maintainAspectRatio: false,
        cutout: '78%',
        plugins: {
          legend: {
            position: 'right',
            labels: {
              boxWidth: 12,
              boxHeight: 12,
              padding: 14,
              usePointStyle: true,
              pointStyle: 'circle'
            }
          }
        }
      }

    });

    this.monthlyChart = new Chart("monthlyChart", {

      type: 'bar',

      data: {

        labels: [],

        datasets: [

          {

            label: 'Incidents',

            data: [],

            backgroundColor: ['#6AAEC0', '#5FA4B7', '#5599AC', '#4A8FA2', '#3F8597', '#347A8C'],

            borderColor: '#00566A',

            borderWidth: 1,

            borderRadius: 6,

            maxBarThickness: 30

          }

        ]

      },
      options: {
        animation: false,
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          }
        }
      }

    });

    this.incidentDataSource.paginator = this.paginator;

    this.recomputeDashboardMetrics();
    this.isDashboardChartsReady = true;
    this.updateDashboardLoadingState();
  }
  raiseIncident() {
    if (this.isNavigatingToDashboard) {
      return;
    }

    this.isNavigatingToDashboard = true;
    this.router.navigate(['/home/admindashboard'])
      .then((navigated) => {
        if (!navigated) {
          this.isNavigatingToDashboard = false;
        }
      })
      .catch(() => {
        this.isNavigatingToDashboard = false;
      });
  }

  private initializeCreateIncidentForm(): void {
    this.popupMode = 'create';
    this.showFormErrors = false;
    this.selectedIncident = null;
    this.incidentForm = {
      usernameOfAffectedCustomer: '',
      accountNumber: '',
      thirdParty: '',
      agentNameShortId: '',
      websitePageScreen: '',
      otherWebsitePage: '',
      country: '',
      incidentTitle: '',
      detailedDescription: '',
      screenshotAttachmentNames: [],
      screenshotAttachments: [],
      screenshotPreviewUrls: [],
      pegaVerificationCompleted: false,
      additionalComments: '',
      customersImpacted: '',
      status: 'Open',
      developerResolution: ''
    };
    this.screenshotValidationError = '';
    this.accountNumberOptions = [];
    this.filteredAccountNumberOptions = [];
    this.accountNumberSearchTerm = '';
    this.isLoadingAccountNumbers = false;
  }

  openIncidentPopup(incident: any): void {
    this.popupMode = 'edit';
    this.showFormErrors = false;
    this.selectedIncident = incident;
    const attachmentNames = this.parseAttachmentNames(incident.screenshotAttachment);
    const existingScreenshots = incident.screenshots || [];
    const derivedScreenshots = attachmentNames.map((name) => {
      const existing = existingScreenshots.find((item) => item.name === name);
      return existing || { name, base64: '', previewUrl: '' };
    });

    const websitePageScreenValue = (incident.websitePageScreen || '').trim();
    const hasWebsitePageOption = this.websitePageOptions.includes(websitePageScreenValue);

    this.incidentForm = {
      usernameOfAffectedCustomer: incident.usernameOfAffectedCustomer || '',
      accountNumber: incident.accountNumber || '',
      thirdParty: incident.thirdParty || '',
      agentNameShortId: this.normalizeAgentNameShortId(incident.agentNameShortId || ''),
      websitePageScreen: hasWebsitePageOption ? websitePageScreenValue : 'Other',
      otherWebsitePage: hasWebsitePageOption ? '' : websitePageScreenValue,
      country: incident.country || '',
      incidentTitle: incident.title || '',
      detailedDescription: incident.detailedDescription || '',
      screenshotAttachmentNames: attachmentNames,
      screenshotAttachments: derivedScreenshots,
      screenshotPreviewUrls: (incident.screenshotPreviews || []).filter((preview) => !!preview),
      pegaVerificationCompleted: (incident.pegaVerificationCompleted || '').toLowerCase() === 'yes',
      additionalComments: incident.additionalComments || 'No additional comments.',
      customersImpacted: incident.customersImpacted || '',
      status: incident.status || 'Open',
      developerResolution: incident.developerResolution || 'Resolution in progress.'
    };
    this.screenshotValidationError = '';
    this.showIncidentPopup = true;
  }

  closeIncidentPopup(): void {
    this.showIncidentPopup = false;
    this.selectedIncident = null;
    this.showFormErrors = false;
    this.screenshotValidationError = '';
  }

  saveIncidentEdits(): void {
    if (this.popupMode === 'create') {
      if (this.isCreatingIncident) {
        return;
      }
      this.saveRaisedIncident();
      return;
    }

    this.showFormErrors = true;

    if (!this.isEditFormValid()) {
      return;
    }

    if (this.isUpdatingIncident) {
      return;
    }

    if (!this.selectedIncident) {
      return;
    }

    this.isUpdatingIncident = true;

    const updateDate = this.formatDateForIncident(new Date());
    const isClosing = this.incidentForm.status === 'Closed';

    const updatedIncidentPayload: IncidentRecord = {
      ...this.selectedIncident,
      additionalComments: this.incidentForm.additionalComments,
      status: this.incidentForm.status,
      developerResolution: this.incidentForm.developerResolution,
      screenshotAttachment: this.incidentForm.screenshotAttachmentNames.join(', '),
      screenshotPreviews: this.incidentForm.screenshotPreviewUrls,
      screenshots: this.incidentForm.screenshotAttachments,
      updatedDate: updateDate,
      closedDate: isClosing ? updateDate : ''
    };

    this.incidentManagementService
      .updateIncident(updatedIncidentPayload)
      .subscribe({
        next: (updatedIncident) => {
          this.isUpdatingIncident = false;

          if (!updatedIncident) {
            if (this.incidentForm.status === 'Cancel' && this.selectedIncident) {
              const removedIncidentId = this.selectedIncident.incidentID;
              this.allIncidents = this.allIncidents.filter((item) => item.incidentID !== removedIncidentId);
              this.applyIncidentTableFilter();
              this.recomputeDashboardMetrics();
              this.closeIncidentPopup();
            }
            return;
          }

          this.allIncidents = this.allIncidents.map((item) =>
            item.incidentID === updatedIncident.incidentID ? updatedIncident : item
          );
          this.applyIncidentTableFilter();
          this.recomputeDashboardMetrics();
          this.closeIncidentPopup();
        },
        error: () => {
          this.isUpdatingIncident = false;
        }
      });
  }

  private isEditFormValid(): boolean {
    const statusValue = (this.incidentForm.status || '').trim().toLowerCase();
    const resolutionValue = (this.incidentForm.developerResolution || '').trim();

    if (statusValue === 'closed' && !resolutionValue) {
      return false;
    }

    return true;
  }

  private saveRaisedIncident(): void {
    this.showFormErrors = true;

    if (!this.isCreateFormValid()) {
      return;
    }

    this.isCreatingIncident = true;

    const shortId = this.extractShortId(this.incidentForm.agentNameShortId);
    const today = new Date();
    const createdDate = today.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }).replace(/ /g, '-');
    const createStatus = 'Open';
    const pageValue = this.resolveWebsitePageScreen();

    const raisedIncident: IncidentRecord = {
      incidentID: 0,
      agentID: shortId,
      pageName: pageValue,
      country: this.incidentForm.country,
      title: this.incidentForm.incidentTitle,
      usernameOfAffectedCustomer: this.incidentForm.usernameOfAffectedCustomer,
      accountNumber: this.incidentForm.accountNumber,
      thirdParty: this.incidentForm.thirdParty,
      agentNameShortId: this.incidentForm.agentNameShortId,
      websitePageScreen: pageValue,
      detailedDescription: this.incidentForm.detailedDescription,
      screenshotAttachment: this.incidentForm.screenshotAttachmentNames.join(', '),
      screenshotPreviews: this.incidentForm.screenshotPreviewUrls,
      screenshots: this.incidentForm.screenshotAttachments,
      pegaVerificationCompleted: this.incidentForm.pegaVerificationCompleted ? 'Yes' : 'No',
      additionalComments: this.incidentForm.additionalComments,
      customersImpacted: this.incidentForm.customersImpacted,
      developerResolution: this.incidentForm.developerResolution,
      status: createStatus,
      resolution: '',
      createdDate,
      updatedDate: createdDate,
      closedDate: ''
    };

    this.incidentManagementService.createIncident(raisedIncident).subscribe({
      next: (createdIncident) => {
        this.isCreatingIncident = false;

        if (!createdIncident) {
          return;
        }

        this.allIncidents = [createdIncident, ...this.allIncidents.filter((item) => item.incidentID !== createdIncident.incidentID)];
        this.applyIncidentTableFilter();
        this.recomputeDashboardMetrics();
        this.closeIncidentPopup();
      },
      error: () => {
        this.isCreatingIncident = false;
      }
    });
  }

  hasRenderableScreenshots(incident: IncidentRecord): boolean {
    return (incident.screenshots || []).some((item) => !!item.previewUrl || !!item.base64);
  }

  getScreenshotNames(incident: IncidentRecord): string[] {
    const names = (incident.screenshots || []).map((item) => (item.name || '').trim()).filter((name) => !!name);
    if (names.length) {
      return names;
    }
    return this.parseAttachmentNames(incident.screenshotAttachment);
  }

  openScreenshot(previewUrl: string): void {
    if (!previewUrl) {
      return;
    }

    window.open(previewUrl, '_blank');
  }

  downloadScreenshot(screenshot: IncidentScreenshotPayload): void {
    const source = screenshot.previewUrl || screenshot.base64;
    if (!source) {
      return;
    }

    const link = document.createElement('a');
    link.href = source;
    link.download = screenshot.name || 'incident-screenshot.png';
    link.target = '_blank';
    link.rel = 'noopener';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  private isCreateFormValid(): boolean {
    const requiredTextFields = [
      this.incidentForm.usernameOfAffectedCustomer,
      this.incidentForm.accountNumber,
      this.incidentForm.thirdParty,
      this.incidentForm.agentNameShortId,
      this.incidentForm.websitePageScreen,
      this.incidentForm.country,
      this.incidentForm.incidentTitle,
      this.incidentForm.detailedDescription,
      this.incidentForm.customersImpacted
    ];

    const hasMissingField = requiredTextFields.some((value) => !value || !value.toString().trim());
    const isOtherWebsitePageInvalid = this.incidentForm.websitePageScreen === 'Other'
      && !this.incidentForm.otherWebsitePage.trim();
    const hasRequiredScreenshot = !this.isScreenshotRequired || this.incidentForm.screenshotAttachments.length > 0;
    const isPegaVerified = this.incidentForm.pegaVerificationCompleted;
    const customerImpact = Number(this.incidentForm.customersImpacted);
    const invalidCustomerImpact = Number.isNaN(customerImpact) || customerImpact <= 0;

    return !hasMissingField && !isOtherWebsitePageInvalid && hasRequiredScreenshot && isPegaVerified && !invalidCustomerImpact;
  }

  onWebsitePageSelectionChange(): void {
    if (this.incidentForm.websitePageScreen !== 'Other') {
      this.incidentForm.otherWebsitePage = '';
    }
  }

  private resolveWebsitePageScreen(): string {
    const selectedWebsitePage = this.incidentForm.websitePageScreen.trim();
    if (selectedWebsitePage !== 'Other') {
      return selectedWebsitePage;
    }

    return this.incidentForm.otherWebsitePage.trim();
  }

  private extractShortId(agentNameShortId: string): string {
    const value = (agentNameShortId || '').trim();
    const parts = value.split('/');
    if (parts.length > 1) {
      return parts[parts.length - 1].trim();
    }
    return value;
  }

  private normalizeAgentNameShortId(agentNameShortId: string): string {
    const value = (agentNameShortId || '').trim();
    if (!value.includes('/')) {
      return value;
    }

    const parts = value
      .split('/')
      .map((part) => part.trim())
      .filter((part) => !!part);

    if (!parts.length) {
      return '';
    }

    if (parts.length === 1) {
      return parts[0];
    }

    return parts[0] === parts[parts.length - 1]
      ? parts[0]
      : `${parts[0]} / ${parts[parts.length - 1]}`;
  }

  private applyIncidentPrefillFromSession(): void {
    const payload = sessionStorage.getItem('incidentPrefill');
    if (!payload) {
      return;
    }

    try {
      const prefill = JSON.parse(payload);
      this.initializeCreateIncidentForm();
      const selectedUserId = (prefill.selectedUserId || prefill.usernameOfAffectedCustomer || '').trim();
      this.incidentForm.usernameOfAffectedCustomer = prefill.usernameOfAffectedCustomer || '';
      this.incidentForm.accountNumber = '';
      this.incidentForm.thirdParty = '';
      this.incidentForm.agentNameShortId = this.normalizeAgentNameShortId(prefill.agentNameShortId || '');

      if (selectedUserId) {
        this.isOpeningIncidentForm = true;
        this.loadAccountNumberOptions(selectedUserId, () => {
          this.isOpeningIncidentForm = false;
          this.showIncidentPopup = true;
        });
      } else {
        this.showIncidentPopup = true;
      }
    } catch (error) {
      this.isOpeningIncidentForm = false;
      // Ignore malformed prefill data and continue with default form.
    }

    sessionStorage.removeItem('incidentPrefill');
  }

  private loadAccountNumberOptions(userId: string, onLoaded?: () => void): void {
    const normalizedUserId = (userId || '').trim();
    if (!normalizedUserId) {
      this.accountNumberOptions = [];
      this.filteredAccountNumberOptions = [];
      this.accountNumberSearchTerm = '';
      this.incidentForm.accountNumber = '';
      this.incidentForm.thirdParty = '';
      if (onLoaded) {
        onLoaded();
      }
      return;
    }

    this.isLoadingAccountNumbers = true;
    this.incidentManagementService.getAccountNumbersForUser(normalizedUserId).subscribe({
      next: (accountOptions) => {
        this.accountNumberOptions = accountOptions.filter((item) => {
          const optionValue = (item.accountNumber || '').trim().toLowerCase();
          return !!optionValue && optionValue !== normalizedUserId.toLowerCase();
        });
        this.filteredAccountNumberOptions = [...this.accountNumberOptions];
        this.accountNumberSearchTerm = '';

        if (!this.incidentForm.thirdParty.trim()) {
          this.incidentForm.thirdParty = this.resolveDefaultThirdPartyId(this.accountNumberOptions);
        }

        const currentOption = this.accountNumberOptions.find((item) => item.accountNumber === this.incidentForm.accountNumber);
        if (!currentOption) {
          this.incidentForm.accountNumber = this.accountNumberOptions.length === 1
            ? this.accountNumberOptions[0].accountNumber
            : '';
        }

        this.syncThirdPartyIdFromAccountSelection();
      },
      error: () => {
        this.accountNumberOptions = [];
        this.filteredAccountNumberOptions = [];
        this.accountNumberSearchTerm = '';
        this.incidentForm.thirdParty = '';
        this.isLoadingAccountNumbers = false;
        if (onLoaded) {
          onLoaded();
        }
      },
      complete: () => {
        this.isLoadingAccountNumbers = false;
        if (onLoaded) {
          onLoaded();
        }
      }
    });
  }

  searchAccountNumbers(): void {
    const searchValue = (this.accountNumberSearchTerm || '').trim().toLowerCase();
    if (!searchValue) {
      this.filteredAccountNumberOptions = [...this.accountNumberOptions];
      return;
    }

    this.filteredAccountNumberOptions = this.accountNumberOptions.filter((accountNumber) =>
      accountNumber.accountNumber.toLowerCase().includes(searchValue)
    );
  }

  onAccountNumberSelectionChange(): void {
    this.syncThirdPartyIdFromAccountSelection();
  }

  private syncThirdPartyIdFromAccountSelection(): void {
    const selectedAccountNumber = (this.incidentForm.accountNumber || '').trim();
    if (!selectedAccountNumber) {
      return;
    }

    const selectedOption = this.accountNumberOptions.find((item) => item.accountNumber === selectedAccountNumber);
    this.incidentForm.thirdParty = selectedOption?.thirdPartyId || '';
  }

  private resolveDefaultThirdPartyId(options: IncidentAccountOption[]): string {
    const firstMatch = options.find((item) => !!(item.thirdPartyId || '').trim());
    return firstMatch ? firstMatch.thirdPartyId.trim() : '';
  }

  onScreenshotFilesSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const files = input?.files ? Array.from(input.files) : [];

    if (!files.length) {
      this.incidentForm.screenshotAttachmentNames = [];
      this.incidentForm.screenshotAttachments = [];
      this.incidentForm.screenshotPreviewUrls = [];
      this.screenshotValidationError = '';
      return;
    }

    const hasInvalidFileType = files.some((file) => !file.type.startsWith('image/'));
    if (hasInvalidFileType) {
      this.incidentForm.screenshotAttachmentNames = [];
      this.incidentForm.screenshotAttachments = [];
      this.incidentForm.screenshotPreviewUrls = [];
      this.screenshotValidationError = 'Only image files are allowed.';
      input.value = '';
      return;
    }

    const allowedFiles = files.slice(0, 3);

    if (files.length > 3) {
      this.incidentForm.screenshotAttachmentNames = allowedFiles.map((file) => file.name);
      this.screenshotValidationError = 'You can upload up to 3 images only.';
    } else {
      this.incidentForm.screenshotAttachmentNames = allowedFiles.map((file) => file.name);
      this.screenshotValidationError = '';
    }

    Promise.all(allowedFiles.map((file) => this.convertFileToScreenshotPayload(file))).then((payloads) => {
      this.incidentForm.screenshotAttachments = payloads;
      this.incidentForm.screenshotPreviewUrls = payloads.map((payload) => payload.previewUrl);
    });
  }

  private convertFileToScreenshotPayload(file: File): Promise<IncidentScreenshotPayload> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const result = reader.result as string;
        resolve({
          name: file.name,
          base64: result,
          previewUrl: result
        });
      };

      reader.onerror = () => reject(new Error('Unable to read screenshot file.'));
      reader.readAsDataURL(file);
    });
  }

  private parseAttachmentNames(attachmentValue: string): string[] {
    if (!attachmentValue) {
      return [];
    }

    return attachmentValue
      .split(',')
      .map((item) => item.trim())
      .filter((item) => !!item);
  }

  private loadIncidents(): void {
    this.incidentManagementService.getIncidents().subscribe({
      next: (data) => {
        this.allIncidents = data;
        this.applyIncidentTableFilter();
        this.recomputeDashboardMetrics();
        this.isDashboardDataReady = true;
        this.updateDashboardLoadingState();
      },
      error: () => {
        this.isDashboardDataReady = true;
        this.updateDashboardLoadingState();
      }
    });
  }

  private applyIncidentTableFilter(): void {
    this.incidents = this.allIncidents.filter((item) =>
      !['closed', 'cancel'].includes((item.status || '').toLowerCase())
    );
    this.incidentDataSource.data = this.incidents;
    this.incidentDataSource.paginator?.firstPage();
  }

  private recomputeDashboardMetrics(): void {
    this.totalIncidents = this.allIncidents.length;
    this.openIncidents = 0;
    this.inProgressIncidents = 0;
    this.closedIncidents = 0;

    for (const incident of this.allIncidents) {
      switch (this.normalizeStatus(incident.status)) {
        case 'open':
          this.openIncidents += 1;
          break;
        case 'in progress':
          this.inProgressIncidents += 1;
          break;
        case 'closed':
          this.closedIncidents += 1;
          break;
      }
    }

    this.updateStatusChart();
    this.updateMonthlyChart();
  }

  private updateStatusChart(): void {
    if (!this.statusChart) {
      return;
    }

    this.statusChart.data.datasets[0].data = [
      this.openIncidents,
      this.inProgressIncidents,
      this.closedIncidents
    ];
    this.statusChart.update('none');
  }

  private updateMonthlyChart(): void {
    if (!this.monthlyChart) {
      return;
    }

    const now = new Date();
    const monthKeys: string[] = [];
    const monthLabels: string[] = [];
    for (let monthOffset = 5; monthOffset >= 0; monthOffset -= 1) {
      const monthDate = new Date(now.getFullYear(), now.getMonth() - monthOffset, 1);
      const monthKey = `${monthDate.getFullYear()}-${String(monthDate.getMonth() + 1).padStart(2, '0')}`;
      monthKeys.push(monthKey);
      monthLabels.push(monthDate.toLocaleString('en-US', { month: 'short' }));
    }

    const monthCountMap = new Map<string, number>(monthKeys.map((key) => [key, 0]));

    this.allIncidents.forEach((incident) => {
      const createdDate = this.parseIncidentCreatedDate(incident.createdDate);
      if (!createdDate) {
        return;
      }

      const monthKey = `${createdDate.getFullYear()}-${String(createdDate.getMonth() + 1).padStart(2, '0')}`;
      if (!monthCountMap.has(monthKey)) {
        return;
      }

      monthCountMap.set(monthKey, (monthCountMap.get(monthKey) || 0) + 1);
    });

    const series = monthKeys.map((key) => monthCountMap.get(key) || 0);

    this.monthlyChart.data.labels = monthLabels;
    this.monthlyChart.data.datasets[0].data = series;
    this.monthlyChart.update('none');
  }

  private parseIncidentCreatedDate(createdDate: string): Date | null {
    if (!createdDate) {
      return null;
    }

    const parsedDate = new Date(createdDate);
    if (!Number.isNaN(parsedDate.getTime())) {
      return parsedDate;
    }

    const matched = createdDate.match(/^(\d{2})-([A-Za-z]{3})-(\d{4})/);
    if (matched) {
      const day = Number(matched[1]);
      const monthIndex = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec']
        .indexOf(matched[2].toLowerCase());
      const year = Number(matched[3]);
      if (monthIndex > -1) {
        return new Date(year, monthIndex, day);
      }
    }

    return null;
  }

  private formatDateForIncident(date: Date): string {
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }).replace(/ /g, '-');
  }

  private normalizeStatus(status: string): string {
    return (status || '').toLowerCase().trim();
  }

  private buildStatusChartGradients(context?: CanvasRenderingContext2D): {
    open: string | CanvasGradient;
    inProgress: string | CanvasGradient;
    closed: string | CanvasGradient;
  } {
    if (!context) {
      return {
        open: '#fff2db',
        inProgress: '#e6f4ff',
        closed: '#e7f6ec'
      };
    }

    const open = context.createLinearGradient(0, 0, 160, 160);
    open.addColorStop(0, '#fff8eb');
    open.addColorStop(1, '#f3cf7a');

    const inProgress = context.createLinearGradient(0, 0, 160, 160);
    inProgress.addColorStop(0, '#eef7ff');
    inProgress.addColorStop(1, '#7fb6eb');

    const closed = context.createLinearGradient(0, 0, 160, 160);
    closed.addColorStop(0, '#effbf3');
    closed.addColorStop(1, '#89c59f');

    return {
      open,
      inProgress,
      closed
    };
  }

  private updateDashboardLoadingState(): void {
    this.isDashboardLoading = !(this.isDashboardDataReady && this.isDashboardChartsReady);
  }

  private resolvePegaLoginUrl(usUrl: string): string {
    const normalized = (usUrl || '').toLowerCase();

    const isExplicitStageUrl = normalized.includes('dtfs-stg.daimler-truckfinancial.com/home')
      || normalized.includes('dtfs-stg.daimler-truckfinancial.com/');

    if (isExplicitStageUrl) {
      return this.pegaStageUrl;
    }

    const isExplicitProdUrl = normalized.includes('daimler-truckfinancial.com/home')
      || normalized.includes('daimler-truckfinancial.com/');

    if (isExplicitProdUrl && !normalized.includes('dtfs-stg.')) {
      return this.pegaProdUrl;
    }

    const hasStageHint = normalized.includes('stg')
      || normalized.includes('stage');

    const hasProdHint = normalized.includes('prod') || normalized.includes('production');

    if (hasStageHint && !hasProdHint) {
      return this.pegaStageUrl;
    }

    if (hasProdHint && !hasStageHint) {
      return this.pegaProdUrl;
    }

    return environment.production ? this.pegaProdUrl : this.pegaStageUrl;
  }

}
